// @flow
import formatWhenLessThanOneHour from './duration-usage-formatter';

function formatValue(seconds: ?number): string {
  if (!seconds || seconds <= 3600) {
    return formatWhenLessThanOneHour(seconds);
  }

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  return hours + 'h ' + (minutes <= 9 ? `0${minutes}` : minutes) + 'm';
}

export default formatValue;
